"use client";

import React from "react";
import { SupDirectionalIndicator } from "@repo/core-ui";
import { SupLinkExternal } from "@repo/core-ui";

import { classNames, formatCurrencyCompact } from "@/utils";

interface ExploitsSectionProps {
  title: string;
  content: string;
  link?: string;
}

export default function ExploitsSection({ title, content, link }: ExploitsSectionProps) {
  return (
    <div className={classNames("mx-4 flex h-[52px] items-center border-b-[0.5px] border-[#404040]  font-mono text-base tracking-wider last:border-b-[0px]")}>
      <p className="w-[70px] text-xs sm:w-[120px]">{title}</p>
      <div className="flex w-full items-center justify-between">
        <SupDirectionalIndicator direction="down" value={formatCurrencyCompact(parseFloat(content))} />

        {link && (
          <div className="flex items-center gap-2 hover:cursor-pointer hover:opacity-60" onClick={() => window.open(link, "_blank")}>
            <p className="text-xs">VIEW THE POST-MORTEM</p>
            <SupLinkExternal className="stroke-0" />
          </div>
        )}
      </div>
    </div>
  );
}
